module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "block fixed inset-x-0 bottom-0 z-10 bg-gray-100 shadow"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('router-link', {
    staticClass: "w-full justify-center inline-block text-center pt-2 pb-1",
    attrs: {
      "to": "/cirugias"
    }
  }, [_c('i', {
    staticClass: "fas fa-syringe"
  }), _c('div', {
    staticClass: "tab tab-home block text-xs"
  }, [_vm._v("Cirugias")])]), _c('router-link', {
    staticClass: "w-full justify-center inline-block text-center pt-2 pb-1",
    attrs: {
      "to": "/gastos"
    }
  }, [_c('i', {
    staticClass: "fas fa-hand-holding-usd"
  }), _c('div', {
    staticClass: "tab tab-home block text-xs"
  }, [_vm._v("Gastos")])]), _c('a', {
    staticClass: "w-full justify-center inline-block text-center pt-2 pb-1",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-out-alt"
  }), _c('div', {
    staticClass: "tab tab-home block text-xs"
  }, [_vm._v("Cerrar Sesión")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dfea667","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_menu_bottom.vue
// module id = 234
// module chunks = 1